import { Navigate, Route, Routes } from "react-router-dom";
import { domAnimation, LazyMotion, MotionConfig } from "motion/react";
import { PublicTool } from "./pages/PublicTool";
import { PrivacyPage } from "./pages/PrivacyPage";
import { AdminLoginPage } from "./pages/admin/AdminLoginPage";
import { AdminSubmissionsPage } from "./pages/admin/AdminSubmissionsPage";
import { AdminSubmissionDetailPage } from "./pages/admin/AdminSubmissionDetailPage";
import { AdminRoute } from "./pages/admin/AdminRoute";
import { ReviewModeBanner } from "./components/ReviewModeBanner";
import { TeamSetupPage } from "./pages/team/TeamSetupPage";
import { TokenExchangePage } from "./pages/team/TokenExchangePage";
import { ParticipantInvitePage } from "./pages/team/ParticipantInvitePage";
import { ParticipantInvitationPage } from "./pages/team/ParticipantInvitationPage";
import { TeamParticipantPage } from "./pages/team/TeamParticipantPage";
import { WorkspacePage } from "./pages/team/WorkspacePage";
import { ProfilePage } from "./pages/team/ProfilePage";
import { BrandingPage } from "./pages/team/BrandingPage";
import { RunWorkspacePage } from "./pages/team/RunWorkspacePage";
import { AdminTeamRunsPage } from "./pages/admin/AdminTeamRunsPage";
import { AdminTeamRunDetailPage } from "./pages/admin/AdminTeamRunDetailPage";
import { ActionNoticeProvider } from "./components/ActionNotice";

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={domAnimation} strict>
        <ActionNoticeProvider>
          <ReviewModeBanner />
          <Routes>
            <Route path="/" element={<PublicTool />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/team" element={<TeamSetupPage />} />
        <Route path="/team/organiser/verify" element={<TokenExchangePage surface="organiser" />} />
        <Route path="/team/organiser" element={<Navigate to="/team/workspace" replace />} />
        <Route path="/team/workspace" element={<WorkspacePage />} />
        <Route path="/team/workspace/profile" element={<ProfilePage />} />
        <Route path="/team/workspace/branding" element={<BrandingPage />} />
        <Route path="/team/workspace/runs/:runId" element={<RunWorkspacePage />} />
        <Route path="/team/respond/:participantToken" element={<ParticipantInvitePage />} />
        <Route path="/team/invitation/:token" element={<ParticipantInvitationPage />} />
        <Route path="/team/participant/verify" element={<TokenExchangePage surface="participant" />} />
        <Route path="/team/participant" element={<TeamParticipantPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<Navigate to="/admin/submissions" replace />} />
        <Route element={<AdminRoute />}>
          <Route path="/admin/submissions" element={<AdminSubmissionsPage />} />
          <Route path="/admin/submissions/:id" element={<AdminSubmissionDetailPage />} />
          <Route path="/admin/team" element={<AdminTeamRunsPage />} />
          <Route path="/admin/team/:id" element={<AdminTeamRunDetailPage />} />
        </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ActionNoticeProvider>
      </LazyMotion>
    </MotionConfig>
  );
}
